import { ThemeColorsKeys } from '../../styles/tokens/colors';

export default {
  circleBorderColor: 'brandTwo100',
  circleHoverBorderColor: 'brandOne80',
  circleHoverBackgroundColor: 'brandOne80',
  hoverColour: 'brandTwo100',
} as Record<string, ThemeColorsKeys>;
